import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

const LabelledPicture = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 24px 24px 0;
  
  .labelledpicture--picture {
    border-radius: 5px;
    background-size: cover;
    min-height: 150px;
    min-width: 180px;
    border: 1px solid #f0f0f0;
  }
  
  .labelledpicture--title {
    font-size: 24px;
    color: rgb(102, 102, 102);
    margin-top: 13px;
  }
`;

const PictureGridContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const PictureGrid = ({ assetPrefix, assets }) => (
  <PictureGridContainer>
    {
      assets.map(a => (
        <LabelledPicture key={a[0]}>
          <div className='labelledpicture--picture' style={{ backgroundImage: `url(${assetPrefix}${a[1]})` }} />
          <div className='labelledpicture--title'>{a[0]}</div>
        </LabelledPicture>
      ))
    }
  </PictureGridContainer>
);

PictureGrid.defaultProps = {

};

PictureGrid.propTypes = {
  assets: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  assetPrefix: PropTypes.string.isRequired,
};

export default PictureGrid;



// WEBPACK FOOTER //
// ./src/components/picture-grid.jsx